import fournisseurMock from "@/mock/fournisseurs.json";
import {carteFournisseur} from "@/types/fournisseur";

import {getDataMock} from "./_callApi";

export async function getFournisseurs(): Promise<carteFournisseur[]> {
  if (getDataMock()) {
    const fournisseurs: carteFournisseur[] = fournisseurMock;
    return fournisseurs;
  } else {
    const fournisseurs: carteFournisseur[] = fournisseurMock;
    return fournisseurs;
  }
}
